import Cookies from "js-cookie";
import {
  getCountryList,
  getAdministrationList,
} from "@/api/subcontractor-register";
export default {
  name: "regionConfig",
  data() {
    return {
      headers: {
        Authorization: Cookies.get("access_token") || "",
      },
      paramsData: "100029",
      defaultArea: [],
      leftPlace: "left",
      areaUrl:
        this.$addUrlPerFix(process.env.VUE_APP_BASE_URL) +
        "/apis/sra/users/signup/subconauthaccountinfo/getAdministrationList",
    };
  },
  methods: {
    // 获取选择之后的地址
    getAddressOf(cityValue) {
      this.extForm.subconBaseInfo.countrys = [];
      //this.extForm.subconBaseInfo.countrys.push(this.code)
      let cityName = [];
      cityValue.forEach((i) => {
        this.extForm.subconBaseInfo.countrys.push(i.code);
        cityName.push(i.name);
      });
      // debugger;
      this.extForm.subconBaseInfo.inputValue = cityName.join("/");
      if (this.extForm.subconBaseInfo.inputValue) {
        this.extForm.subconBaseInfo.country = cityName[0];
        this.extForm.subconBaseInfo.countryCode = cityValue[0].code
        this.extForm.subconBaseInfo.province = cityName[1];
        this.extForm.subconBaseInfo.provinceCode = cityValue[1].code
        this.extForm.subconBaseInfo.city = cityName[2] ? cityName[2] : "";
        this.extForm.subconBaseInfo.cityCode = cityValue[2] ? cityValue[2].code : "";
        this.extForm.subconBaseInfo.county = cityName[3] ? cityName[3] : "";
        this.extForm.subconBaseInfo.countyCode = cityValue[3] ? cityValue[3].code : "";
        //this.$refs.myCascader.inputValue = this.extForm.subconBaseInfo.inputValue;
        this.extForm.subconBaseInfo.attribute2 = JSON.stringify(
          this.extForm.subconBaseInfo.countrys
        );
      }
      this.inputValueValid1();
    },
    handleSignPlace() {
      var tmp = this.extForm.subconBaseInfo.countrys.split("/");
      this.defaultArea = [];
      for (let i = 0; i < this.extForm.subconBaseInfo.countrys.length; i++) {
        try {
          this.defaultArea.push({
            level: i + 1,
            name: tmp[i],
            code: this.extForm.subconBaseInfo.inputValue[i],
          });
          /*this.$refs.scmaAreaSelector.qryAddressOfFourth(
            this.defaultArea[i],
            "",
            true
          );*/
          // eslint-disable-next-line no-empty
        } catch (e) {}
      }
    },
    setSignPlace(val) {
      this.$refs["myCascader"].inputValue = val;
    },
    getSignPlace() {
      return this.$refs["myCascader"].inputValue;
    },
    // 省市区change
    handlerCascaderChange(data) {
      setTimeout(() => {
        this.$nextTick(() => {
          this.getLabelValue(data);
        });
      }, 100);
    },
    getLabelValue(data) {
      if (this.$refs["myCascader"].inputValue) {
        this.extForm.subconBaseInfo.province = data[0];
        this.extForm.subconBaseInfo.city = data[1];
        this.extForm.subconBaseInfo.county = data[2];
        this.extForm.subconBaseInfo.inputValue =
          this.$refs.myCascader.inputValue;
      }
    },
    // 地区log
    cascaderShow(data) {
      console.log(data, "------2-2-2-2-");
    },
  },
};
